import React, { useEffect, useState } from "react";
import iconFilePdf from "../../../assets/media/icon-file-pdf.svg";
import iconFileXls from "../../../assets/media/icon-file-xls.svg";
import iconFileImage from "../../../assets/media/icon-file-image.svg";
import iconFileDoc from "../../../assets/media/icon-file-doc.svg";
import iconFileEdit from "../../../assets/media/icon-file-edit.svg";
import iconSearch from "../../../assets/media/icon-search.svg";
import iconCaretLeft from "../../../assets/media/icon-caret-left.svg";
import iconCaretRight from "../../../assets/media/icon-caret-right.svg";
import iconCaretDown from "../../../assets/media/icon-caret-down.svg";

import { Link } from "react-router-dom";
import Navbar from "../../navbar";
import Header from "../../header";
import { useDispatch, useSelector } from "react-redux";
import { fetchApplications, clearApplications } from "../../../store/reducers/applicationSlice";
import Pagination from "../dashboard/appPagination";
import { formatDate } from "../dashboard/aapDashboard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const AppDraft = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const authToken = user.access_token;

  const applications = useSelector((state) => state.applications);
  const pagination = useSelector((state) => state.applications.pagination);
  const applicationLoading = useSelector((state) => state.applications.fetchLoading);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const getallUserdata = useSelector((state) => state.userdata.getalluserdata);
  const [filteredApplication, setFilteredApplication] = useState([]);

  const [searchBy, setSearchBy] = useState("applicationId");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Clear applications when component mounts to ensure fresh data
  useEffect(() => {
    dispatch(clearApplications());
  }, [dispatch]);

  useEffect(() => {
    let queryParams = {
      page: currentPage,
      limit: itemsPerPage || 10,
      state: "draft"
    };

    if (searchQuery && searchQuery.trim() !== '') {
      queryParams[searchBy] = searchQuery.trim();
    }

    if (startDate) {
      queryParams.createdFrom = moment(startDate).format("YYYY-MM-DD");
    }
    if (endDate) {
      queryParams.createdTo = moment(endDate).format("YYYY-MM-DD");
    }

    dispatch(
      fetchApplications({ accessToken: authToken, queryParams: queryParams })
    );
  }, [authToken, dispatch, startDate, endDate, currentPage, searchQuery, itemsPerPage, searchBy]);

  useEffect(() => {
    const applicationsArray = Array.isArray(applications.data)
      ? applications.data
      : applications.data?.applications || applications.data?.data || [];

    if (applicationsArray.length > 0 && getallUserdata.length > 0) {
      const mergedData = applicationsArray.map((appItem) => {
        const userItem = getallUserdata.find(
          (userData) => userData.id === appItem.user_id
        );
        if (userItem) {
          return {
            ...appItem,
            applicationId: appItem.id,
            ...userItem,
            userId: userItem.id,
          };
        }
        return { ...appItem, applicationId: appItem.id };
      });

      // Since we're using server-side filtering, we only need to filter by company_id
      const filteredData = mergedData.filter(
        (item) => item.company_id === user.user.company_id
      );

      setFilteredApplication(filteredData);
      console.log(filteredData, "Filtered Data");
    }
  }, [applications.data, getallUserdata, user.user.company_id]);

  const handleSearchInputChange = (e) => {
    let value = e.target.value;
    if (searchBy === "applicationId") {
      value = value.replace(/^gb-?/i, "").replace(/\D/g, "");
    }
    setSearchQuery(value);
    setCurrentPage(1);
  };

  const handleSearchByChange = (e) => {
    setSearchBy(e.target.value);
    setSearchQuery("");
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to page 1 when changing items per page
  };

  const getTotalPages = () => {
    // Use server-side pagination metadata
    if (pagination?.totalPages) {
      return pagination.totalPages;
    }
    // Fallback to client-side calculation
    const validItemsPerPage = itemsPerPage || 10;
    return Math.ceil(filteredApplication.length / validItemsPerPage);
  };

  return (
    <div>
      <Navbar />
      <Header />
      <div className="wrapper">
        <div className="boxAppBoard boxWhite">
          <div
            className="boardHeader"
            style={{ flexWrap: "wrap", gap: "10px" }}
          >
            <div className="boardHeadLeft">
              <h2>Draft</h2>
            </div>
            <div
              className="boardHeadRight"
              style={{
                gap: "10px",
                flexWrap: "wrap",
                justifyContent: "flex-start",
              }}
            >
              <div className="">
                <select onChange={handleSearchByChange} value={searchBy}>
                  <option value="applicationId">Search by Application ID</option>
                  <option value="companyName">Search by Company Name</option>
                  <option value="username">Search by Employee Name</option>
                  {/* <option value="email">Search by Email </option> */}
                </select>
              </div>
              <div className="searchForm">
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleSearchInputChange}
                  value={searchQuery}
                />
                <button>
                  <img src={iconSearch} alt="" />
                </button>
              </div>
              <div className="datePicker">
                <DatePicker
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    const [start, end] = update;
                    setStartDate(start);
                    setEndDate(end);
                    setCurrentPage(1);
                  }}
                  isClearable={true}
                  placeholderText="Select Date Range"
                  className="date-range-input"
                  dateFormat="yyyy-MM-dd"
                />
              </div>
            </div>
          </div>
          <div className="boardContent" style={{ position: 'relative' }}>
            {/* Loader overlay for content section */}
            {applicationLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 10,
                  borderRadius: '4px'
                }}
              >
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 mb-0">Loading applications...</p>
                </div>
              </div>
            )}
            {applicationLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ padding: "40px" }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <div className="boardThead">
                  <div className="boardCol w-85">S.NO.</div>
                  <div className="boardCol w-165">Application No.</div>
                  <div className="boardCol w-adj2">Application Name</div>
                  <div className="boardCol w-165">Last Fill</div>
                  <div className="boardCol w-355">Completed</div>
                  <div className="boardCol w-165">{/* Attachments */}</div>
                  <div className="boardCol w-110"></div>
                </div>
                {filteredApplication.length > 0 ? (
                  filteredApplication
                    .sort((a, b) => b.applicationId - a.applicationId)
                    .map((item, index) => (
                      <div
                        className="boardTrow"
                        key={item.id}
                      >
                        <div className="boardCol w-85">{index + 1}</div>
                        <div className="boardCol w-165">
                          {`GB-${item.applicationId}`}
                        </div>
                        <div className="boardCol w-adj2">
                          <div className="boardTitle">
                            <strong>{item.name}</strong>
                            <span>{item.category}</span>
                          </div>
                        </div>
                        <div className="boardCol w-165">
                          {formatDate(item.created_at)}
                        </div>
                        <div className="boardCol w-355">
                          <div className="progressWrap">
                            <div
                              className="progress"
                              role="progressbar"
                              aria-valuenow="50"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              <div
                                className="progress-bar progWorking"
                                style={{ width: "50%" }}
                              ></div>
                            </div>
                            <div className="progressStatus">50%</div>
                          </div>
                        </div>
                        <div className="boardCol w-165">
                          <div className="boardDownload">
                            {/* <Link to={'/'}><img src={iconFilePdf} alt='' /></Link>
                                            <Link to={'/'}><img src={iconFileDoc} alt='' /></Link>
                                            <Link to={'/'}><img src={iconFileImage} alt='' /></Link> */}
                          </div>
                        </div>
                        <div className="boardCol w-110">
                          <div className="boardActions">
                            <Link to={"/"}>
                              <img src={iconFileEdit} alt="" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="boardTrow">
                    <div className="boardCol" style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
                      {applicationLoading ? "Loading..." : "Result not found"}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={getTotalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default AppDraft;
